<template>
  <div
    class="dental-formula"
    v-if="isNotEmpty">
    <div class="dental-formula__schema">
      <div v-if="isPermanentBite" class="dental-formula__row">
        <tooth-up-8
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[18]"
          v-bind:tooth="teeth[18]"
          v-bind:disabled="disabled"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-7
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[17]"
          v-bind:tooth="teeth[17]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-6
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[16]"
          v-bind:tooth="teeth[16]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[15]"
          v-bind:tooth="teeth[15]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[14]"
          v-bind:tooth="teeth[14]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[13]"
          v-bind:tooth="teeth[13]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[12]"
          v-bind:tooth="teeth[12]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[11]"
          v-bind:tooth="teeth[11]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[21]"
          v-bind:tooth="teeth[21]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[22]"
          v-bind:tooth="teeth[22]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[23]"
          v-bind:tooth="teeth[23]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[24]"
          v-bind:tooth="teeth[24]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[25]"
          v-bind:tooth="teeth[25]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-6
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[26]"
          v-bind:tooth="teeth[26]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-7
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[27]"
          v-bind:tooth="teeth[27]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-8
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[28]"
          v-bind:tooth="teeth[28]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
      </div>
      <div v-if="isMilkBite" class="dental-formula__row milk">
        <tooth-up-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:is-milky="true"
          v-bind:selected-parts="selectedPartIds[55]"
          v-bind:tooth="teeth[55]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[54]"
          v-bind:tooth="teeth[54]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[53]"
          v-bind:tooth="teeth[53]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[52]"
          v-bind:tooth="teeth[52]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[51]"
          v-bind:tooth="teeth[51]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[61]"
          v-bind:tooth="teeth[61]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[62]"
          v-bind:tooth="teeth[62]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[63]"
          v-bind:tooth="teeth[63]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[64]"
          v-bind:tooth="teeth[64]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-up-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:is-milky="true"
          v-bind:selected-parts="selectedPartIds[65]"
          v-bind:tooth="teeth[65]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:is-milky="true"
          v-bind:selected-parts="selectedPartIds[85]"
          v-bind:tooth="teeth[85]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[84]"
          v-bind:tooth="teeth[84]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[83]"
          v-bind:tooth="teeth[83]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[82]"
          v-bind:tooth="teeth[82]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[81]"
          v-bind:tooth="teeth[81]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[71]"
          v-bind:tooth="teeth[71]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[72]"
          v-bind:tooth="teeth[72]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[73]"
          v-bind:tooth="teeth[73]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[74]"
          v-bind:tooth="teeth[74]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:is-milky="true"
          v-bind:selected-parts="selectedPartIds[75]"
          v-bind:tooth="teeth[75]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
      </div>
      <div v-if="isPermanentBite" class="dental-formula__row">
        <tooth-down-8
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[48]"
          v-bind:tooth="teeth[48]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-7
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[47]"
          v-bind:tooth="teeth[47]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-6
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[46]"
          v-bind:tooth="teeth[46]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[45]"
          v-bind:tooth="teeth[45]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[44]"
          v-bind:tooth="teeth[44]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[43]"
          v-bind:tooth="teeth[43]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-2
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[42]"
          v-bind:tooth="teeth[42]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:selected-parts="selectedPartIds[41]"
          v-bind:tooth="teeth[41]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-1
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[31]"
          v-bind:tooth="teeth[31]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-2
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[32]"
          v-bind:tooth="teeth[32]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-3
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[33]"
          v-bind:tooth="teeth[33]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-4
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[34]"
          v-bind:tooth="teeth[34]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-5
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[35]"
          v-bind:tooth="teeth[35]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-6
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[36]"
          v-bind:tooth="teeth[36]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-7
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[37]"
          v-bind:tooth="teeth[37]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
        <tooth-down-8
          v-bind:disabled="disabled"
          v-bind:diagnoses="diagnoses"
          v-bind:flip="true"
          v-bind:selected-parts="selectedPartIds[38]"
          v-bind:tooth="teeth[38]"
          v-on:part-selected="onPartSelected"
          v-on:submit="emitChangeTooth" />
      </div>
    </div>
    <form-part-diagnoses
      v-bind:class="{ 'disable-component': disabled }"
      class="dental-formula__form"
      v-bind:deleted-value="selectedToothDeletedValue"
      v-bind:part-list="partsForMultiSelect"
      v-if="shownForm"
      v-on:cancel="onCloseForm"
      v-on:change-diagnoses="onChangeDiagnoses"
      v-on:change-tooth-deleted="onChangeToothDeleted"
      v-on:submit="onSubmitForm" />
  </div>
</template>

<script>
import toothMixin from '@/mixins/toothMixin';
import FormPartDiagnoses from './FormPartDiagnoses.vue';
import ToothDown1 from './teeth/ToothDown1.vue';
import ToothDown2 from './teeth/ToothDown2.vue';
import ToothDown3 from './teeth/ToothDown3.vue';
import ToothDown4 from './teeth/ToothDown4.vue';
import ToothDown5 from './teeth/ToothDown5.vue';
import ToothDown6 from './teeth/ToothDown6.vue';
import ToothDown7 from './teeth/ToothDown7.vue';
import ToothDown8 from './teeth/ToothDown8.vue';
import ToothUp1 from './teeth/ToothUp1.vue';
import ToothUp2 from './teeth/ToothUp2.vue';
import ToothUp3 from './teeth/ToothUp3.vue';
import ToothUp4 from './teeth/ToothUp4.vue';
import ToothUp5 from './teeth/ToothUp5.vue';
import ToothUp6 from './teeth/ToothUp6.vue';
import ToothUp7 from './teeth/ToothUp7.vue';
import ToothUp8 from './teeth/ToothUp8.vue';

/**
 * @description Название события изменения диагнозов зуба.
 * @type {string}
 */
const NAME_EVENT_CHANGE_TOOTH_DIAGNOSES = 'change-tooth-diagnoses';

/**
 * @description Название события изменения диагнозов части зуба.
 * @type {string}
 */
const NAME_EVENT_CHANGE_TOOTH_PART_DIAGNOSES = 'change-tooth-part-diagnoses';

/**
 * @description Название события изменения диагнозов зубов.
 * @type {string}
 */
const NAME_EVENT_CHANGE_TEETH = 'change-teeth';

export default {
  components: {
    FormPartDiagnoses,
    ToothDown1,
    ToothDown2,
    ToothDown3,
    ToothDown4,
    ToothDown5,
    ToothDown6,
    ToothDown7,
    ToothDown8,
    ToothUp1,
    ToothUp2,
    ToothUp3,
    ToothUp4,
    ToothUp5,
    ToothUp6,
    ToothUp7,
    ToothUp8,
  },
  computed: {
    /**
     * @description Номера выбранных зубов.
     * @type {number[]}
     */
    selectedToothNumbers() {
      return Object.keys(this.selectedTooth).map((number) => Number(number));
    },
    /**
     * @description Количество выбранных частей.
     * @returns {Map<string,number>}
     */
    selectedPartsGroupByIdCount() {
      const parts = new Map();
      this.toothForEach((part) => {
        const partId = part.id;
        const count = parts.has(partId) ? parts.get(partId) + 1 : 1;
        parts.set(partId, count);
      });
      return parts;
    },
    /**
     * @description Выбранные диагнозы частей зубов.
     * @returns {Map<number,Map<string,string[]>>}
     */
    selectedToothPartDiagnoses() {
      const teeth = new Map();
      this.selectedToothNumbers.forEach((number) => {
        const parts = new Map();
        this.selectedTooth[number].forEach((part) => {
          if (toothMixin.methods.isSelectedSurface(part.id)) {
            parts.set(toothMixin.SURFACES_PART_NAME, part.diagnoses);
          } else if (toothMixin.methods.isSelectedCanal(part.id)) {
            parts.set(toothMixin.CANALS_PART_NAME, part.diagnoses);
          } else {
            parts.set(part.id, part.diagnoses);
          }
        });
        teeth.set(number, parts);
      });
      return teeth;
    },
    /**
     * @description Уникальные части зубов.
     * @type {Map<string,Object>}
     */
    uniqueParts() {
      const parts = new Map();
      this.toothForEach((part) => {
        const isSelectedSurface = toothMixin
          .methods
          .isSelectedSurface(part.id);
        const isSelectedCanal = toothMixin
          .methods
          .isSelectedCanal(part.id);
        if (isSelectedSurface) {
          parts.set(toothMixin.SURFACES_PART_NAME, part);
        } else if (isSelectedCanal) {
          parts.set(toothMixin.CANALS_PART_NAME, part);
        } else {
          parts.set(part.id, part);
        }
      });
      return parts;
    },
    /**
     * @description Список частей для изменения диагнозов у выбранных зубов.
     * @type {Array}
     */
    partsForMultiSelect() {
      const isContains = (toothNumber, partId, diagnosisId) => {
        const parts = this.selectedToothPartDiagnoses.get(toothNumber);
        if (parts.has(partId)) {
          return parts.get(partId).includes(diagnosisId);
        }
        return false;
      };
      return Array.from(this.uniqueParts.keys()).map((partId) => {
        const isSurfaces = toothMixin.methods.isSelectedSurface(partId);
        const isCanals = toothMixin.methods.isSelectedCanal(partId);
        if (isSurfaces) {
          return this.getSurfacePart(partId, isContains);
        }
        if (isCanals) {
          return this.getCanalPart(partId, isContains);
        }
        return this.getOrdinaryPart(partId, isContains);
      });
    },
    /**
     * @description Выбранные части зубов.
     * @type {Object.<number, string[]}
     */
    selectedPartIds() {
      const result = this
        .selectedToothNumbers
        .map((number) => [number, this.selectedTooth[number].map(({ id }) => id)]);
      return Object.fromEntries(result);
    },
    /**
     * @description Значение наличия диагноза "Зуб удален" у выбранных зубов.
     * @type {string}
     */
    selectedToothDeletedValue() {
      const selectedToothCount = this.selectedToothNumbers.length;
      if (this.deletedTeeth.size === 0) {
        return 'empty';
      } if (selectedToothCount === this.deletedTeeth.size) {
        return 'all';
      }
      return 'any';
    },
    /**
     * @description Номера удаленных зубов.
     * @type {number[]}
     */
    initialDeletedToothNumbers() {
      const filter = (number) => !!this.teeth[number]
        .parts
        .find(({ id }) => id === 'crown')
        .diagnoses
        .find(({ id }) => id === 'delete');
      return Object.keys(this.teeth).filter(filter).map((number) => Number(number));
    },
    isNotEmpty() {
      return Object.values(this.teeth).length > 0;
    },
    isMilkBite() {
      return this.biteMode === 'mixed' || this.biteMode === 'milk';
    },
    isPermanentBite() {
      return this.biteMode === 'mixed' || this.biteMode === 'permanent';
    },
  },
  data() {
    return {
      /**
       * @description Выбранные зубы.
       * @type {Object.<number,Array>}
       */
      selectedTooth: {},
      /**
       * @description Показывать форму.
       * @type {boolean}
       */
      shownForm: false,
      /**
       * @description Удаленные зубы.
       * @type {Set}
       */
      deletedTeeth: new Set(),
    };
  },
  methods: {
    /**
     * Взять часть для поверностей зуба
     *
     * @param partId
     * @param {function} isContains
     * @returns {{name: string, id: string, diagnoses: *}}
     */
    getSurfacePart(partId, isContains) {
      const diagnoses = this.diagnoses.central_surface;
      return {
        id: toothMixin.SURFACES_PART_NAME,
        name: 'Поверхности',
        diagnoses: diagnoses.map((diagnosis) => {
          const selectedDiagnosisCount = this
            .selectedToothNumbers
            .filter((number) => isContains(number, partId, diagnosis.id)).length;
          let value = 'all';
          if (selectedDiagnosisCount === 0) {
            value = 'empty';
          }
          return {
            diagnosis,
            value,
          };
        }),
      };
    },
    /**
     * Взять часть для каналов зуба
     *
     * @param partId
     * @param {function} isContains
     * @returns {{name: string, id: string, diagnoses: *}}
     */
    getCanalPart(partId, isContains) {
      const diagnoses = this.diagnoses.cheek_canal;
      return {
        id: toothMixin.CANALS_PART_NAME,
        name: 'Каналы',
        diagnoses: diagnoses.map((diagnosis) => {
          const selectedDiagnosisCount = this
            .selectedToothNumbers
            .filter((number) => isContains(number, partId, diagnosis.id)).length;
          let value = 'all';
          if (selectedDiagnosisCount === 0) {
            value = 'empty';
          }
          return {
            diagnosis,
            value,
          };
        }),
      };
    },
    /**
     * Взять часть обычных составляющих зуба
     *
     * @param partId
     * @param {function} isContains
     * @returns {{name: string, id: string, diagnoses: *}}
     */
    getOrdinaryPart(partId, isContains) {
      const part = this.uniqueParts.get(partId);
      const diagnoses = this.diagnoses[partId];
      const selectedPartCount = this.selectedPartsGroupByIdCount.get(partId);
      return {
        id: part.id,
        name: part.name,
        diagnoses: diagnoses.map((diagnosis) => {
          const selectedDiagnosisCount = this
            .selectedToothNumbers
            .filter((number) => isContains(number, partId, diagnosis.id)).length;
          let value = 'any';
          if (selectedDiagnosisCount === selectedPartCount) {
            value = 'all';
          } else if (selectedDiagnosisCount === 0) {
            value = 'empty';
          }
          return {
            diagnosis,
            value,
          };
        }),
      };
    },
    /**
     * @description Перебрать части выбранных зубов.
     * @param {function} cb Обратный вызов.
     * @returns {void}
     */
    toothForEach(cb) {
      this.selectedToothNumbers.forEach((number) => {
        this.selectedTooth[number].forEach((part) => {
          cb(part, number);
        });
      });
    },
    /**
     * @description Обработать изменение диагнозов у выбранных частей зубов.
     * @param {string}  partId      Идентификатор части.
     * @param {string}  diagnosisId Идентификатор диагноза.
     * @param {boolean} isSelected  Выбран.
     * @returns {void}
     */
    onChangeDiagnoses(partId, diagnosisId, isSelected) {
      const isCrownDeleted = partId === 'crown' && diagnosisId === 'delete';
      const isSurfaceSelected = toothMixin
        .methods
        .isSelectedSurface(partId);
      const isCanalSelected = toothMixin
        .methods
        .isSelectedCanal(partId);
      if (isSurfaceSelected) {
        this.changeSurfacesDiagnoses(diagnosisId, isSelected);
        return;
      }
      if (isCanalSelected) {
        this.changeCanalsPartDiagnoses(diagnosisId, isSelected);
        return;
      }
      this.changeOrdinaryPartDiagnoses(partId, diagnosisId, isSelected, isCrownDeleted);
    },
    /**
     * Изменить диагнозы для обычных частей зуба
     *
     * @param partId
     * @param diagnosisId
     * @param isSelected
     * @param isCrownDeleted
     *
     * @returns {void}
     */
    changeOrdinaryPartDiagnoses(partId, diagnosisId, isSelected, isCrownDeleted) {
      this.selectedToothNumbers.forEach((number) => {
        this
          .selectedTooth[number]
          .filter((part) => part.id === partId)
          .forEach((part) => {
            if (isCrownDeleted) {
              if (isSelected) {
                this.deletedTeeth.add(number);
              } else {
                this.deletedTeeth.delete(number);
              }
            }
            const diagnosisIndex = part.diagnoses.indexOf(diagnosisId);
            const isContains = diagnosisIndex !== -1;
            if (isSelected && !isContains) {
              part.diagnoses.push(diagnosisId);
            } else if (!isSelected && isContains) {
              this.$delete(part.diagnoses, diagnosisIndex);
            }
          });
      });
    },
    /**
     * Изменить диагнозы для части зуба "Каналы"
     *
     * @param diagnosisId
     * @param isSelected
     * @return {void}
     */
    changeCanalsPartDiagnoses(diagnosisId, isSelected) {
      this.selectedToothNumbers.forEach((number) => {
        this
          .selectedTooth[number]
          .filter((part) => toothMixin.methods.isSelectedCanal(part.id))
          .forEach((part) => {
            const diagnosisIndex = part.diagnoses.indexOf(diagnosisId);
            const isContains = diagnosisIndex !== -1;
            if (isSelected && !isContains) {
              part.diagnoses.push(diagnosisId);
            } else if (!isSelected && isContains) {
              this.$delete(part.diagnoses, diagnosisIndex);
            }
          });
      });
      this.deletedTeeth = new Set(this.deletedTeeth.values());
    },
    /**
     * Изменить диагнозы для части зуба "Поверхность"
     *
     * @param diagnosisId
     * @param isSelected
     * @return {void}
     */
    changeSurfacesDiagnoses(diagnosisId, isSelected) {
      this.selectedToothNumbers.forEach((number) => {
        this
          .selectedTooth[number]
          .filter((part) => toothMixin.methods.isSelectedSurface(part.id))
          .forEach((part) => {
            const diagnosisIndex = part.diagnoses.indexOf(diagnosisId);
            const isContains = diagnosisIndex !== -1;
            if (isSelected && !isContains) {
              part.diagnoses.push(diagnosisId);
            } else if (!isSelected && isContains) {
              this.$delete(part.diagnoses, diagnosisIndex);
            }
          });
      });
      this.deletedTeeth = new Set(this.deletedTeeth.values());
    },
    /**
     * @description Обработать удаление зуба.
     * @param {boolean} isDeleted
     * @return {void}
     */
    onChangeToothDeleted(isDeleted) {
      if (isDeleted) {
        this.deletedTeeth = new Set(this.selectedToothNumbers);
      } else {
        this.deletedTeeth = new Set();
      }
      this.selectedToothNumbers.forEach((number) => {
        this.selectedTooth[number]
          .filter(({ id }) => id === 'crown')
          .forEach((crown) => {
            const index = crown.diagnoses.indexOf('delete');
            const isContains = index > -1;
            if (isContains && !isDeleted) {
              this.$delete(crown.diagnoses, index);
            } else if (!isContains && isDeleted) {
              crown.diagnoses.push('delete');
            }
          });
      });
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmitForm() {
      const makeCrown = (number, needDelete) => {
        const crown = this.teeth[number].parts.find(({ id }) => id === 'crown');
        const diagnoses = crown.diagnoses.map(({ id }) => id);
        const index = diagnoses.indexOf('delete');
        if (!needDelete && index > -1) {
          diagnoses.splice(index, 1);
        } else if (needDelete && index === -1) {
          diagnoses.push('delete');
        }
        return {
          id: crown.id,
          name: crown.name,
          diagnoses,
        };
      };
      const teeth = this.selectedToothNumbers.map((number) => {
        const isInitialDeleted = this.initialDeletedToothNumbers.includes(number);
        const isDeleted = this.deletedTeeth.has(number);
        const parts = this.selectedTooth[number];
        if (isInitialDeleted !== isDeleted) {
          const isContains = !!parts.find(({ id }) => id === 'crown');
          if (isContains) {
            return parts;
          }
          const crown = makeCrown(number, isDeleted);
          return [...parts, crown];
        }
        return parts;
      });
      const changedTeeth = {};
      teeth.forEach((parts, index) => {
        const number = this.selectedToothNumbers[index];
        changedTeeth[number] = parts;
      });
      this.selectedTooth = {};
      this.shownForm = false;
      this.$emit(NAME_EVENT_CHANGE_TEETH, changedTeeth);
    },
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onCloseForm() {
      this.selectedTooth = {};
      this.shownForm = false;
    },
    /**
     * @description Обработать выделение части зуба.
     * @param {number} toothNumber Номер зуба.
     * @param {string} partId      Идентификатор части зуба.
     * @returns {void}
     */
    onPartSelected(toothNumber, partId) {
      const isAll = partId === 'all';
      const isToothSelected = toothNumber in this.selectedTooth;
      const tooth = this.teeth[toothNumber];
      const parts = isAll
        ? tooth.parts
        : tooth.parts.filter((candidate) => candidate.id === partId);
      const collectParts = () => parts.map((part) => ({
        id: part.id,
        name: part.name,
        diagnoses: part.diagnoses.map(({ id }) => id),
      }));
      if (isToothSelected) {
        const selectedParts = this.selectedTooth[toothNumber];
        if (!isAll) {
          const partIndex = selectedParts.findIndex((candidate) => candidate.id === partId);
          if (partIndex > -1) {
            this.$delete(selectedParts, partIndex);
          } else {
            selectedParts.push(...collectParts());
          }
        }
        if (isAll || selectedParts.length === 0) {
          this.$delete(this.selectedTooth, toothNumber);
          this.deletedTeeth.delete(toothNumber);
        }
      } else {
        if (this.initialDeletedToothNumbers.includes(toothNumber)) {
          this.deletedTeeth.add(toothNumber);
        }
        this.$set(this.selectedTooth, toothNumber, collectParts());
      }
      this.deletedTeeth = new Set(this.deletedTeeth.values());
      this.shownForm = Object.keys(this.selectedTooth).length > 0;
    },
    /**
     * @description Отправить событие изменения частей зуба.
     * @param {number}   toothNumber Номер зуба.
     * @param {Part[]}   parts Части.
     * @returns {void}
     */
    emitChangeTooth(toothNumber, parts) {
      if (parts.length > 1) {
        this.$emit(NAME_EVENT_CHANGE_TOOTH_DIAGNOSES, toothNumber, parts);
      } else {
        const [part] = parts;
        this.$emit(NAME_EVENT_CHANGE_TOOTH_PART_DIAGNOSES, toothNumber, part);
      }
    },
  },
  name: 'DentalFormula',
  provide() {
    return {
      onlyView: this.onlyView,
    };
  },
  props: {
    /**
     * @description Только просмотр.
     * @type {boolean}
     */
    onlyView: { default: () => false, type: Boolean },
    /**
     * @description Диагнозы.
     * @type {Object.<string,Diagnosis>}
     */
    diagnoses: { type: Object, required: true },
    /**
     * @description Зубы.
     * @type {Object.<number,Tooth>}
     */
    teeth: { type: Object, required: true },
    /**
     * @description Прикус.
     * @type {boolean}
     */
    biteMode: { type: String, required: true },
    /**
     * @description Деактивировано.
     */
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.tooth {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  &__body {
    width: 100%;
    position: relative;
    display: grid;
    grid-template-rows: 66px 25px 30px;
    &__bone {
      background-color: #ffead2;
      height: 100%;
      &:hover,
      &.selected {
        border: 2px solid var(--action-color);
      }
    }
    &__gingiva {
      background-color: #f4ddc1;
      height: 100%;
      &:hover,
      &.selected {
        border: 2px solid var(--action-color);
      }
    }
    &__all-tooth {
      &:hover,
      &.selected {
        border: 2px solid var(--action-color);
      }
    }
  }
  &__parts {
    width: 68px;
    position: absolute;
    top: 14.28px;
    pointer-events: none;
    &.flip {
      transform: scaleX(-1);
    }
    path {
      stroke: #778f9f;
      pointer-events: all;
      &:hover,
      &.selected {
        stroke-width: 2px;
        stroke: var(--action-color);
      }
    }
    #implant {
      path,
      rect {
        &:hover {
          stroke-width: inherit;
          stroke: #778F9F;
        }
      }
    }
  }
  &__number {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    padding: 2px 0px;
  }
}
.all-tooth {
  height: 40px;
  background-color: transparent;
  &:hover,
  &.selected {
    border: 2px solid var(--action-color);
  }
}

.dental-formula {
  display: flex;
  flex-direction: row;
  margin-top: 29px;
  padding: 19px 10px;
  background-color: #ffffff;
  border-radius: 8px;
  width: fit-content;
  &__schema {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__row {
    display: grid;
    grid-template-columns: repeat(16, 66px);
    align-items: center;
    text-align: center;
    &.milk {
      grid-template-columns: repeat(10, 66px);
    }
  }
  &__form {
    height: auto !important;
    max-height: 456px !important;
  }
}

.disable-component {
  pointer-events: none;
}

@media screen and (max-width: 1560px) {
  .tooth {
    &__parts {
      width: 100%;
    }
  }
  .dental-formula {
    &__row {
      grid-template-columns: repeat(16, 62px);
    }
  }
}
@media screen and (max-width: 1430px) {
  .dental-formula {
    width: 100%;
    overflow-y: auto;
  }
}
</style>
